import MetaTags from "react-meta-tags"
import React, { useState, useEffect, useRef } from "react"
import { Container, Row, Col, Button } from "reactstrap"
import { useHistory, withRouter, Link } from "react-router-dom"

import Loader from '../../components/Common/Loader';
import SimpleReactValidator from 'simple-react-validator';
import { post, get } from '../../helpers/api_helper';
import { POST_UPDATE_SETTING, GET_ALL_SETTING } from '../../helpers/url_helper';
import { IsModemAccess } from '../../helpers/helper';
import { toast } from 'react-toastify';
//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"


const AdminForm = props => {
    let history = useHistory();

    if (!IsModemAccess('app_setting', 'edit')) {
        toast('Does not permission this module');
        history.push("/");
    }
    const [isLoader, setLoader] = useState(0);
    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState();
    const [, forceUpdate] = useState();

    useEffect(() => {
        async function get_detaile() {
            await get_app_setting();
            setLoader(1);
        }
        get_detaile();
    }, [])

    const get_app_setting = async () => {
        var res_data = await get(GET_ALL_SETTING + "?type=otp-setting");
        if (res_data.status) {
            await setInputs(res_data.data);
        } else {
            toast.error(res_data.message);
        }
    }

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_UPDATE_SETTING, form_inputs, {});
            if (res_data.status) {
                await get_app_setting();
                toast(res_data.message);
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        if (
            event.target.name === 'email_otp_enable'
        ) {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: (event.target.checked) ? '1' : '0' }));
        } else {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
        }
    }

    if (!isLoader) {
        return (<Loader></Loader>);
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Otp Setting | Free Money Coins</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumb title="Dashboard" breadcrumbItem="Otp Setting" />

                    <Row>
                        <Col lg="4">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className="border card-body rounded bg-light-box">
                                    <Row>
                                        <Col lg="12" >
                                            <div className="form-group mb-3">
                                                <label className="form-label text-capitalize">Admin Email OTP Limit</label>
                                                <input name="admin_email_otp_limit" value={form_inputs.admin_email_otp_limit} onChange={handleInputChange} className="form-control" placeholder={`Enter Admin Email OTP Limit`} type="text" />
                                                {simpleValidator.current.message('email OTP limit', form_inputs.admin_email_otp_limit, 'required')}
                                            </div>
                                            <div className="row mb-3 mt-4">
                                                <div className="col-8">
                                                    <label className="form-label text-capitalize">Email Send Enable</label>
                                                </div>
                                                <div className="col-4">
                                                    <div className="form-check form-switch form-switch-md mt-0" dir="ltr">
                                                        <input name="email_otp_enable" onChange={handleInputChange} defaultChecked={parseInt(form_inputs.email_otp_enable)} type="checkbox" className="form-check-input" />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="12" >
                                            <div className="text-center mt-4">
                                                <Button disabled={ButtonDisabled} type="submit" color="primary">{ButtonDisabled && <i className="fas fa-spinner me-2 fa-spin"></i>} Update</Button>
                                                <Link to="/setting" className="btn btn-danger ms-3"> Cancel</Link>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </form>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )
}

export default withRouter(AdminForm)
